import {
  ApiAuthorization,
  ApiAuthorizationNextStep,
  ApiAuthorizationTokenType,
} from "@/types/employees/employee.types.ts";

export type AuthorizationFlow = "complete" | "tfa_code" | "tfa_setup" | "organization_select";

export const getAuthorizationFlow = (authorization: ApiAuthorization): AuthorizationFlow => {
  if (authorization.token_type === ApiAuthorizationTokenType.organization_pending) {
    return "organization_select";
  }

  if (authorization.token_type === ApiAuthorizationTokenType.tfa_pending) {
    return "tfa_code";
  }

  if (authorization.next_step === ApiAuthorizationNextStep.tfa_setup) {
    return "tfa_setup";
  }

  return "complete";
};
